import React from 'react'

const Taglia = ({ isActive, taglia, onClick, last = false, className }) => {
  return (
    <>
      <p
        className={`taglia ${isActive ? 'taglia__active' : ''} ${className ? className : ''}`}
        onClick={onClick}
      >
        {taglia}
      </p>
      {!last && <p> - </p>}
    </>
  )
}

export default Taglia
